<script setup>
import { getLeavesInfo } from '@/services/leave.services';

export default {
    data() {
        return {
            leaves: null,
        };
    },
    async mounted() {
        this.$Spin.show();
        await this.getRemainingLeaves();
        this.$nextTick(() => {
            this.$Spin.hide();
        });
    },
    methods: {
        async getRemainingLeaves() {
            const { data } = await getLeavesInfo();
            this.leaves = data;
        },
    },
};
</script>

<template>
    <div>
        Remaining Leaves <br />
        <Tag color="blue">VL: {{ leaves['remaining-vacation-leave'] }} </Tag>
        <Tag color="purple">SL: {{ leaves['remaining-sick-leave'] }} </Tag>
    </div>
</template>

<style scoped lang="scss"></style>
